<main class="d-flex flex-column p-6">
  <!-- Main Modal Container -->
  <div class="w-100">
    <!-- Modal Header & Top Actions -->
    <div class="d-flex justify-content-between align-items-center w-100 bg-custom-gray p-3">
      <div class="flex items-center gap-3">
        <span class="fs-14px text-white"><b>Alta Carátula Bancaria</b></span>
      </div>
      <div class="d-flex  align-items-center gap-2">
        <button class="btn btn-success" (click)="enviarValidacionCaratulaBancaria(1)">
          ALTA REALIZADA
        </button>
        <button class="btn btn-warning" (click)="enviarValidacionCaratulaBancaria(2)">
          ALTA REGRESADA
        </button>
        <button class="btn btn-danger" (click)="enviarValidacionCaratulaBancaria(3)">
          ALTA RECHAZADA
        </button>
        <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
            <i class="fa-solid fa-square-xmark"></i>
        </span>
      </div>
    </div>
    <!-- General Info Section -->
    <div class="row col-12 p-3">
      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Clave Proveedor</b></label>
        <input class="form-control" disabled  type="text" [value]="proveedor.claveProveedor">
      </div>
      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Solicitante</b></label>
        <input class="form-control" disabled  type="text" [value]="proveedor.solicitante">
      </div>
      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Jefe Directo</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.jefeDirecto">
      </div>
      <div class="col-4 d-flex flex-column">
        <label class="font-label-caps text-label-caps text-on-surface-variant">Estatus</label>
        <input class="form-control" disabled [value]="proveedor.estatusProveedor">
      </div>

      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Nombre Proveedor</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.nombreProveedor">
      </div>

      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Tipo Persona</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.tipoProveedorDescripcion">
      </div>

      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Razón Social</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.razonSocial">
      </div>
      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Regimen Fiscal</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.regimenFiscalDescripcion">
      </div>
      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>RFC</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.rfc">
      </div>

      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Nombre Titular</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.nombreTitular">
      </div>

      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Banco</b></label>
        <input class="form-control" disabled type="text" [value]="proveedor.banco">
      </div>
      <div class="col-4 d-flex flex-column">
        <label class="fs-12px"><b>Datos Bancarios (CLABE / Cuenta)</b></label>
        <div class="flex items-center gap-3">
          <input class="form-control" disabled type="text" [value]="proveedor.numerodeCuenta">
        </div>
      </div>
      <div class="col-12 d-flex flex-column">
        <label class="fs-12px"><b>Empresas</b></label>
        <div class="flex items-center gap-3">
          <input class="form-control" disabled type="text" [value]="empresasProveedor">
        </div>
      </div>
    </div>
    <!-- Document Viewer Section -->
    <div class="p-2">
        <div class="pdf-preview">
            <iframe [src]="pdfSrc" style="width: 100%;" height="400"></iframe>
        </div>
    </div>
    <!-- Modal Footer -->
    <!-- <div class="p-2 d-flex flex-row align-items-center justify-content-end">
      <button class="btn btn-secondary" routerLink="/">CERRAR</button>
      <button class="btn btn-success" routerLink="/">GUARDAR CAMBIOS</button>
    </div> -->
  </div>
</main>
